import { Form } from "antd";
import { useForm } from "antd/es/form/Form";
import deepEqual from "fast-deep-equal";
import { useEffect, useState } from "react";

function useFormHandler() {
	const [formRef]: any = useForm();
	const [formReset, setFormReset] = useState<boolean>(true);
	const [initialForm, setInitialForm] = useState<any>(null);
	const values = Form.useWatch([], formRef);

	useEffect(() => {
		if (initialForm && formReset == false) {
			const valuesChanged = !deepEqual(values, initialForm);
			if (valuesChanged) {
				setFormReset(false);
			} else {
				setFormReset(true);
			}
		}
	}, [values, initialForm]);

	const resetForm = (values: any = null) => {
		if (formRef) {
			setFormReset(true);
			formRef.resetFields();
			formRef.setFieldsValue(values);
			setInitialForm(values);
		}
	};

	return {
		formRef,
		formReset,
		setFormReset,
		initialForm,
		setInitialForm,
		resetForm,
	};
}

export default useFormHandler;
